/**
 * Data layer for `igaming-license-specific-dashboards-mga-cura-ao-lo`. Thin typed fetch wrappers over /api/v1/igaming-license-specific-dashboards-mga-cura-ao-lo.
 * Raw `fetch()` is confined to this file per the dash contract.
 */

export interface IgamingLicenseSpecificDashboardsMgaCuraAoLoRow {
	id: string;
	tenant_id: string;
	created_at: number;
	updated_at: number;
	[key: string]: unknown;
}

export interface ListIgamingLicenseSpecificDashboardsMgaCuraAoLoResponse {
	count: number;
	items: IgamingLicenseSpecificDashboardsMgaCuraAoLoRow[];
}

export interface CreateIgamingLicenseSpecificDashboardsMgaCuraAoLoBody {
	[key: string]: unknown;
}

const BASE = "/api/v1/igaming-license-specific-dashboards-mga-cura-ao-lo";

async function parseOrThrow<T>(res: Response): Promise<T> {
	const text = await res.text();
	let data: unknown = null;
	if (text) {
		try {
			data = JSON.parse(text);
		} catch {
			data = text;
		}
	}
	if (!res.ok) {
		const msg =
			data &&
			typeof data === "object" &&
			data !== null &&
			"error" in data &&
			typeof (data as { error: unknown }).error === "string"
				? (data as { error: string }).error
				: `HTTP ${res.status}`;
		throw new Error(msg);
	}
	return data as T;
}

export async function list(): Promise<ListIgamingLicenseSpecificDashboardsMgaCuraAoLoResponse> {
	const res = await fetch(BASE, {
		method: "GET",
		credentials: "include",
		headers: { accept: "application/json" },
	});
	return parseOrThrow<ListIgamingLicenseSpecificDashboardsMgaCuraAoLoResponse>(res);
}

export async function create(body: CreateIgamingLicenseSpecificDashboardsMgaCuraAoLoBody): Promise<IgamingLicenseSpecificDashboardsMgaCuraAoLoRow> {
	const res = await fetch(BASE, {
		method: "POST",
		credentials: "include",
		headers: {
			accept: "application/json",
			"content-type": "application/json",
		},
		body: JSON.stringify(body ?? {}),
	});
	return parseOrThrow<IgamingLicenseSpecificDashboardsMgaCuraAoLoRow>(res);
}

export async function remove(id: string): Promise<{ removed: boolean }> {
	const res = await fetch(`${BASE}/${encodeURIComponent(id)}`, {
		method: "DELETE",
		credentials: "include",
		headers: { accept: "application/json" },
	});
	return parseOrThrow<{ removed: boolean }>(res);
}

export const igamingLicenseSpecificDashboardsMgaCuraAoLoQueryKeys = {
	all: ["igaming-license-specific-dashboards-mga-cura-ao-lo"] as const,
	list: () => [...igamingLicenseSpecificDashboardsMgaCuraAoLoQueryKeys.all] as const,
	detail: (id: string) => [...igamingLicenseSpecificDashboardsMgaCuraAoLoQueryKeys.all, id] as const,
};
